import { Checkbox } from 'antd';
import { Checkbox as MobileCheckbox } from 'antd-mobile';
import { useState } from 'react';
import Link from 'next/link';
import SAgreement from './styles.module.scss';
import { useUserAgentInfo } from '../../../context/user-agent';

export default function Agreement({ onChange, text = '阅读并同意StreamLake' }) {
  const [checked, setChecked] = useState(false);
  const { isMobile } = useUserAgentInfo();

  const Protocols = ({ styleName }) => {
    return (
      <>
        <Link
          href={'/policy/StreamLake用户服务协议.html'}
          className={SAgreement[styleName]}
          target="_blank"
          rel="noreferrer"
        >
          “用户服务协议”
        </Link>
        和
        <Link
          href={'/policy/StreamLake隐私政策.html'}
          className={SAgreement[styleName]}
          target="_blank"
          rel="noreferrer"
        >
          “隐私政策”
        </Link>
      </>
    );
  };

  const handleChange = () => {
    onChange(!checked);
    setChecked(!checked);
  };
  return (
    <>
      {isMobile ? (
        <div className={SAgreement.sugProtocolMobileContainer}>
          <MobileCheckbox
            onChange={onChange}
            className={SAgreement.protocolBoxMobile}
          />
          <span className={SAgreement.protocolTextMobile}>
            {text}
            <Protocols />
          </span>
        </div>
      ) : (
        <div className={SAgreement.sugProtocol}>
          <Checkbox
            className={SAgreement.protocolBox}
            onChange={(e) => handleChange(e.target.value)}
            checked={checked}
          />
          <span
            className={SAgreement.protocolText}
            onClick={() => handleChange()}
          >
            {text}
            <Protocols styleName="protocolLink" />
          </span>
        </div>
      )}
    </>
  );
}
